module.exports = __webpack_public_path__ + "img/delete.383d64ea.svg";